import styled from "styled-components";

import { Container, Row, Column } from "@ui/Atoms";

import { GatsbyImage } from "@www/src/components/GatsbyImage";

interface ColumnProps {
  inversed: boolean;
  wide: boolean;
}

export const Root = styled(Container).attrs({ as: "article" })`
  padding-top: ${({ theme }) => theme.spacing.spacing_48};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_48};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_64};
  }
  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_80};
  }
`;

export const Benefit = styled(Row)`
  ${props => props.theme.breakpoints.upToDesktop} {
    gap: ${({ theme }) => theme.spacing.spacing_32};
  }
`;

const offset = {
  pushMd: 1,
  pushLg: 2,
};

const wideOffset = {
  pushMd: 1,
};

export const DescriptionWrapper = styled(Column).attrs<ColumnProps>(props => ({
  sm: 12,
  md: props.wide ? 4 : 5,
  lg: 4,
  orderXs: 1,
  orderMd: props.inversed ? 2 : 1,
  ...(props.inversed ? {} : props.wide ? wideOffset : offset),
}))<ColumnProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.spacing_12};
`;

export const ImageWrapper = styled(Column).attrs<ColumnProps>(props => ({
  as: "figure",
  sm: 12,
  md: props.wide ? 6 : 5,
  lg: props.wide ? 6 : 3,
  orderXs: 2,
  orderMd: props.inversed ? 1 : 2,
  ...(!props.inversed ? {} : props.wide ? wideOffset : offset),
}))<ColumnProps>`
  display: flex;
  justify-content: center;
`;

export const ResponsiveImage = styled(GatsbyImage)`
  width: 210px;

  ${props => props.theme.breakpoints.tablet} {
    width: 170px;
  }

  ${props => props.theme.breakpoints.desktop} {
    width: 170px;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    width: 210px;
  }
`;

export const WideImage = styled(GatsbyImage)`
  width: 100%;
`;
